import React from 'react';
import CustomButton from './CustomButton/CustomButton';

const InfoCard = ({ backgroundImage, text, buttonText = 'Contact Us', onButtonClick }) => {
  return (
    <div
      className="flex items-center justify-center min-h-[400px] py-20 w-full"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="flex flex-col bg-white shadow-md px-10 py-12 w-3/4 text-center mx-auto items-center justify-center rounded-lg">
        <p className="text-xl md:text-2xl mb-6 text-gray-900 !font-serif italic"> {text} </p>
        <CustomButton
          text={buttonText.toUpperCase()}
          onClick={onButtonClick}
          className="!bg-[#34E1A1] !text-black hover:!bg-[#2ECB91] mt-2 px-6 py-2 font-semibold tracking-wide rounded"
        />
      </div>
    </div>
  );
};

export default InfoCard;
